import React from 'react';
import { TPrivateMessage } from '../../../store/privateChat/types';
import { TMessage } from '../../../store/sockets/types';
import { InfoUserType } from '../../../store/users/types';
import { checkUserType } from '../../../utils/checkUserType';
import * as Styles from '../styles';
import { Message } from './Message';

interface ListMessageProps {
  user: InfoUserType | null;
  messages: TMessage[] | null | undefined | TPrivateMessage[];
  likeMessage?: (messageId: number) => void;
  handleChangePage?: () => void;
}

export const ListMessage: React.FC<ListMessageProps> = React.memo(({ user, messages, likeMessage, handleChangePage }) => {
  const [isScroll, setIsScroll] = React.useState(true);
  const refMessagesWrapper = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (refMessagesWrapper.current && isScroll) {
      refMessagesWrapper.current.scrollIntoView();
    }
  }, [refMessagesWrapper, messages, isScroll]);

  const scrollHandler = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const element = e.currentTarget;
    const dif = element.scrollHeight * 0.02;

    if (handleChangePage && element.scrollTop < dif) {
      handleChangePage();
    }

    if (Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 300) {
      !isScroll && setIsScroll(true);
    } else {
      isScroll && setIsScroll(false);
    }
  };

  const renderMessages = React.useMemo(() => {
    if (!messages || !messages[0]) return null;
    return messages.map((mess) => {
      return <Message type={checkUserType(mess, user?.id2)} key={mess.absnum} message={mess} likeMessage={likeMessage} />;
    });
  }, [messages, user, likeMessage]);

  return (
    <Styles.MessagesWrapperS onScroll={scrollHandler}>
      {renderMessages}
      <div ref={refMessagesWrapper} />
    </Styles.MessagesWrapperS>
  );
});
